var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellnessKko4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 60,
    viewBox: "0 0 29 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_986_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4405 4.39877C13.3941 3.49862 13.497 0.685293 16.4877 0.0139654C16.8697 -0.0717146 17.2003 0.252861 17.032 0.550221C16.3657 1.72857 15.3638 4.14777 17.655 5.12957C20.3503 6.28574 15.135 5.07614 13.7762 4.75157C13.5836 4.70621 13.4486 4.56408 13.4405 4.39776V4.39877Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3443 4.02222C21.4405 4.04823 27.1811 9.83104 27.1551 16.9273L27.1481 18.8344C27.1286 24.1445 22.8017 28.4389 17.4926 28.4195L11.0182 28.3957C5.70811 28.3763 1.41373 24.0493 1.43319 18.7402L1.44018 16.8331C1.46619 9.73679 7.24899 3.99622 14.3453 4.02222L14.3443 4.02222Z",
    fill: "#F6B643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49741 53.9636C3.18197 54.7297 4.69498 57.5843 6.22412 57.0712L6.26041 57.0591C6.48015 56.9856 6.713 57.1277 6.74727 57.3565L6.76642 57.4855C7.05269 59.3846 9.29146 59.7838 9.80151 58.0268L9.80655 58.0107C9.87812 57.7627 10.1745 57.6619 10.3831 57.8131C11.7086 58.7778 13.1088 57.3253 12.6048 55.775C12.5876 55.7225 12.5574 55.6752 12.5201 55.6359L9.32876 52.3004C9.22393 52.1905 9.06365 52.1562 8.92253 52.2117L4.49741 53.9636Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6187 56.0154C15.7801 57.2855 18.4009 59.1735 19.5439 58.0355L19.5712 58.0083C19.7355 57.845 20.0066 57.8691 20.1397 58.0587L20.2143 58.1655C21.313 59.741 23.4973 59.106 23.1748 57.3057L23.1717 57.2885C23.1264 57.0345 23.3471 56.8128 23.6011 56.8561C25.217 57.1333 25.8278 55.2111 24.6888 54.0448C24.6505 54.0055 24.6031 53.9763 24.5507 53.9581L20.2112 52.3826C20.0691 52.3312 19.9098 52.3705 19.808 52.4834L16.6177 56.0164L16.6187 56.0154Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3742 25.235C22.2587 25.2639 28.637 31.6891 28.6081 39.5736L28.5944 43.2992C28.5728 49.199 23.7653 53.9714 17.8655 53.9498L10.6715 53.9234C4.77268 53.9018 0.00024958 49.0942 0.0218735 43.1944L0.0355284 39.4689C0.0644268 31.5844 6.48965 25.2061 14.3742 25.235Z",
    fill: "#F6B643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3222 34.1034C20.6302 34.1265 25.7331 39.2669 25.71 45.5749L25.7099 45.5951C25.6926 50.3145 21.8472 54.1329 17.1267 54.1156L11.3711 54.0945C6.65166 54.0772 2.83331 50.2318 2.85061 45.5113L2.85069 45.4912C2.87381 39.1831 8.01419 34.0803 14.3222 34.1034Z",
    fill: "#FAD69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44219 17.4286L6.63587 17.4219C5.88989 17.4192 5.28294 18.0217 5.28021 18.7677L5.2802 18.7687C5.27747 19.5147 5.87998 20.1216 6.62596 20.1244L8.43229 20.131C9.17826 20.1337 9.78521 19.5312 9.78795 18.7852L9.78795 18.7842C9.79068 18.0382 9.18817 17.4313 8.44219 17.4286Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 17.5785L20.0118 17.5718C19.2659 17.5691 18.6589 18.1716 18.6562 18.9176L18.6562 18.9186C18.6534 19.6646 19.256 20.2715 20.0019 20.2743L21.8083 20.2809C22.5542 20.2836 23.1612 19.6811 23.1639 18.9351L23.1639 18.9341C23.1667 18.1881 22.5641 17.5812 21.8182 17.5785Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1504 15.7465C10.6877 15.7445 10.3147 15.2012 10.3167 14.5339C10.3188 13.8656 10.6957 13.3253 11.1584 13.3273C11.1816 13.3273 11.2038 13.3293 11.226 13.3323C10.849 12.8051 10.3349 12.4806 9.76839 12.4775C8.60213 12.4735 7.65158 13.8353 7.64554 15.5207C7.63949 17.2051 8.57995 18.5749 9.74621 18.579C10.9125 18.583 11.863 17.2212 11.8691 15.5358C11.8691 15.4189 11.865 15.305 11.857 15.1921C11.7068 15.5267 11.4467 15.7485 11.1504 15.7475V15.7465Z",
    fill: "#5B3B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3174 14.5338C10.3154 15.2021 10.6883 15.7454 11.151 15.7464C11.4474 15.7474 11.7074 15.5256 11.8576 15.191C11.8042 14.4632 11.5724 13.813 11.2276 13.3312C11.2054 13.3282 11.1823 13.3262 11.1601 13.3262C10.6974 13.3242 10.3204 13.8644 10.3184 14.5328L10.3174 14.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1865 15.7797C19.7238 15.7777 19.3509 15.2344 19.3529 14.5671C19.3549 13.8988 19.7319 13.3585 20.1946 13.3605C20.2177 13.3605 20.2399 13.3625 20.2621 13.3655C19.8851 12.8384 19.371 12.5138 18.8045 12.5108C17.6383 12.5067 16.6877 13.8685 16.6817 15.5539C16.6756 17.2383 17.6161 18.6081 18.7823 18.6122C19.9486 18.6162 20.8991 17.2544 20.9052 15.569C20.9052 15.4521 20.9012 15.3382 20.8931 15.2253C20.7429 15.56 20.4828 15.7817 20.1865 15.7807V15.7797Z",
    fill: "#5B3B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3535 14.5675C19.3515 15.2358 19.7245 15.7791 20.1871 15.7801C20.4835 15.7811 20.7436 15.5593 20.8937 15.2247C20.8403 14.4969 20.6085 13.8467 20.2637 13.3649C20.2416 13.3619 20.2184 13.3599 20.1962 13.3599C19.7335 13.3579 19.3565 13.8981 19.3545 14.5664L19.3535 14.5675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.914 20.579L16.3385 20.1808C16.1278 20.0346 15.8476 19.953 15.5553 19.952L12.9012 19.9419C12.6099 19.9409 12.3287 20.0205 12.117 20.1657L11.5384 20.5598C11.2602 20.7493 11.1453 21.0154 11.1916 21.2694L17.2558 21.2916C17.3041 21.0376 17.1902 20.7715 16.914 20.58V20.579Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1934 21.2686C11.2266 21.449 11.3395 21.6234 11.5361 21.7595L12.1116 22.1576C12.3223 22.3038 12.6025 22.3854 12.8949 22.3864L15.5489 22.3965C15.8402 22.3975 16.1215 22.3179 16.3332 22.1727L16.9117 21.7786C17.1093 21.6435 17.2242 21.4702 17.2585 21.2907L11.1944 21.2686H11.1934Z",
    fill: "#E77A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0953 11.105H8.39987C6.85279 11.105 5.59863 12.3591 5.59863 13.9062V16.7599C5.59863 18.3069 6.85279 19.5611 8.39987 19.5611H10.0953C11.6424 19.5611 12.8966 18.3069 12.8966 16.7599V13.9062C12.8966 12.3591 11.6424 11.105 10.0953 11.105Z",
    stroke: "#72441F",
    strokeWidth: 1.008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0699 11.105H18.3745C16.8274 11.105 15.5732 12.3591 15.5732 13.9062V16.7599C15.5732 18.3069 16.8274 19.5611 18.3745 19.5611H20.0699C21.617 19.5611 22.8712 18.3069 22.8712 16.7599V13.9062C22.8712 12.3591 21.617 11.105 20.0699 11.105Z",
    stroke: "#72441F",
    strokeWidth: 1.008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2705 15.3838L15.3722 15.4221",
    stroke: "#72441F",
    strokeWidth: 1.008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6846 15.383L27.019 15.3145",
    stroke: "#72441F",
    strokeWidth: 1.008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50488 15.383L5.83928 15.3145",
    stroke: "#72441F",
    strokeWidth: 1.008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6142 41.5388C19.0092 37.6489 21.8014 30.8379 22.7852 28.0518C26.6428 30.9659 28.558 35.2539 28.5681 39.2748C25.8838 41.8069 21.3528 43.0659 18.0566 43.6707C16.8601 43.8905 15.9741 42.578 16.6152 41.5378L16.6142 41.5388Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19122 44.9971C6.96442 45.622 7.29101 46.3196 7.91597 46.5464L8.46231 46.745C9.08727 46.9718 9.7848 46.6462 10.0116 46.0202L13.4317 36.5894L10.6144 35.5562L7.19021 44.9971H7.19122Z",
    fill: "#F5CE22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4377 36.5916L13.4356 36.5815L13.4326 36.5896L13.4377 36.5916Z",
    fill: "#ED6A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6045 35.5522L10.6156 35.5562L10.6216 35.5381L10.6045 35.5522Z",
    fill: "#ED6A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1906 34.7588L12.737 34.9573C12.9043 35.0178 13.0484 35.1126 13.1684 35.2295L12.875 33.7417L11.6836 34.6912C11.8509 34.6771 12.0233 34.6973 12.1906 34.7578V34.7588Z",
    fill: "#5B2013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7371 34.9569L12.1907 34.7583C12.0234 34.6979 11.851 34.6777 11.6837 34.6918L10.6213 35.5385L10.6152 35.5567L13.4326 36.5899L13.4356 36.5808L13.1685 35.2301C13.0485 35.1132 12.9044 35.0184 12.7371 34.9579V34.9569Z",
    fill: "#F4B46C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 44.2256L10.2898 45.2485L9.85794 46.4397C9.63048 47.067 8.9358 47.392 8.30847 47.1645L7.76168 46.9662C7.13435 46.7388 6.80938 46.0441 7.03685 45.4168L7.46875 44.2256Z",
    fill: "#ED6A1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6685 36.3291L9.61426 44.8659",
    stroke: "#F4A118",
    strokeWidth: 0.1008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9927 36.083L8.9375 44.6198",
    stroke: "#F4A118",
    strokeWidth: 0.1008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.315 35.813L8.26074 44.3487",
    stroke: "#F4A118",
    strokeWidth: 0.1008,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9529 41.5173C9.55786 37.6274 6.7657 30.8164 5.78189 28.0303C1.92427 30.9434 0.01008 35.2324 0 39.2533C2.6843 41.7854 7.21526 43.0444 10.5114 43.6492C11.7079 43.869 12.594 42.5566 11.9529 41.5163V41.5173Z",
    fill: "#F0851C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3445 45.1313L7.52344 44.1084L7.2465 44.8722L10.0676 45.8951L10.3445 45.1313Z",
    fill: "#3A1507"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_986_747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.608,
    height: 59.1494,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessKko4);
export default __webpack_public_path__ + "static/media/Wellness-kko4.9c754aceb366f8d512c597adf3b6474b.svg";
export { ForwardRef as ReactComponent };